export enum SalesPgStep {
    NO_PRODUCT,
    QUESTIONNAIRE,
    DATA,
    CONFIGURATION
}
